import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import styles from "./tabs.module.scss";
const Tabs = ({ tabs, selectedTab, onTabChange, isScrollToSpotTab, }) => {
    useEffect(() => {
        const spotTab = document.getElementById(selectedTab);
        if (isScrollToSpotTab) {
            spotTab === null || spotTab === void 0 ? void 0 : spotTab.scrollIntoView({
                behavior: "auto",
                block: "center",
                inline: "center",
            });
        }
    }, [tabs]);
    return (_jsx("div", Object.assign({ className: styles.tabs }, { children: tabs.map((tab) => {
            return (_jsxs("div", Object.assign({ className: `${styles.tab} meterTab`, onClick: () => onTabChange(tab.id), id: tab.id }, { children: [_jsx("span", Object.assign({ className: `${selectedTab == tab.id ? "active" : ""} large mediumWeight meterTabLabel` }, { children: tab.label })), _jsx("div", { className: `${styles.indicator} indicatorBorder`, style: {
                            visibility: selectedTab == tab.id ? "visible" : "hidden",
                        } })] }), tab.id));
        }) })));
};
export { Tabs };
function useState(arg0) {
    throw new Error("Function not implemented.");
}
